import { render } from "./UpdateProductModal.vue?vue&type=template&id=8406e5d4"
import script from "./UpdateProductModal.vue?vue&type=script&lang=js"
export * from "./UpdateProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__